import React from "react"
import PropTypes from "prop-types"
import {
    datePickerGenericFilter,
    enumSingleGenericFilter,
    enumOrderSort,
    enumValueSort,
} from "shared/search/containers/Filter/Filters"

import {
    enumGenericFilter,
    searchifySelectGenericFilter,
    toggleGenericFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    OfficialFilterableListView,
    StafferFilterableListView,
    SupporterFilterableListView,
    PressContactFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    CustomEventSelect,
    OfficialSelect,
    StafferSelect,
    ContactSelect,
    PressContactSelect,
} from "app/static/frontend/selects/containers/PieSelect"

const defaultPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,

    dataTypeLabel: PropTypes.string,
    helpText: PropTypes.string,
    selectComponent: PropTypes.func,
    regions: PropTypes.array,
    placeholderText: PropTypes.string,
}

const defaultEnumPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,

    enumItems: PropTypes.array,
    helpText: PropTypes.string,
    sortBy: PropTypes.func,
}

const dateDefaultPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,
}

/** Status */
export const CustomEventParticipantRsvpFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
CustomEventParticipantRsvpFilter.propTypes = defaultEnumPropTypes
CustomEventParticipantRsvpFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "customEventParticipantRsvpFilter",
    filterKey: "rsvp_status__in",
    enumItems: DjangIO.app.custom_event.types.RSVPStatus.region_supported_items(),
    sortBy: enumValueSort,
    displayLabel: "RSVP Status",
}

export const CustomEventParticipantAttendeeStatusFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
CustomEventParticipantAttendeeStatusFilter.propTypes = defaultEnumPropTypes
CustomEventParticipantAttendeeStatusFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "customEventParticipantAttendeeStatusFilter",
    filterKey: "attendee_status__in",
    enumItems: DjangIO.app.custom_event.types.AttendeeStatus.region_supported_items(),
    sortBy: enumValueSort,
    displayLabel: "Attendee Status",
}

export const CustomEventParticipantEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
CustomEventParticipantEventFilter.propTypes = defaultPropTypes
CustomEventParticipantEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "customEventParticipantEventFilter",
    filterKey: "associated_with_event",
    dataTypeLabel: "Invited to Event",
    displayLabel: "Invited to Event",
    selectComponent: CustomEventSelect,
}

// toggle filters for Official/Staffer/Contact
export const CustomEventParticipantOfficialsFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
CustomEventParticipantOfficialsFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
CustomEventParticipantOfficialsFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "customEventParticipantOfficialsFilter",
    filterKey: "sent_to_officials",
    displayLabel: "Official",
    trueText: "Yes",
    falseText: "No",
}

export const CustomEventParticipantStaffersFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
CustomEventParticipantStaffersFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
CustomEventParticipantStaffersFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "customEventParticipantStaffersFilter",
    filterKey: "sent_to_staffers",
    displayLabel: DjangIO.app.models.QuorumDataType.staffer.singular,
    trueText: "Yes",
    falseText: "No",
}

export const CustomEventParticipantContactsFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
CustomEventParticipantContactsFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
CustomEventParticipantContactsFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "customEventParticipantContactsFilter",
    filterKey: "sent_to_supporters",
    displayLabel: "Contact",
    trueText: "Yes",
    falseText: "No",
}

export const CustomEventParticipantPressContactsFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
CustomEventParticipantPressContactsFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
CustomEventParticipantPressContactsFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "customEventParticipantPressContactsFilter",
    filterKey: "sent_to_press",
    displayLabel: DjangIO.app.models.QuorumDataType.press_contact.singular,
    trueText: "Yes",
    falseText: "No",
}

export const CustomEventParticipantInvitedFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
CustomEventParticipantInvitedFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
CustomEventParticipantInvitedFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "customEventParticipantInvitedFilter",
    filterKey: "has_been_invited",
    displayLabel: "Has Been Invited",
    trueText: "Yes",
    falseText: "No",
}

export const CustomEventParticipantBossFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
CustomEventParticipantBossFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
CustomEventParticipantBossFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "customEventParticipantBossFilter",
    filterKey: "boss_will_attend",
    displayLabel: "Boss Will Attend",
    trueText: "Yes",
    falseText: "No",
}

// Searchify Official/Stafer/Contact filters
export const CustomEventParticipantOfficialFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={OfficialFilterableListView} {...props} />
}
CustomEventParticipantOfficialFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
CustomEventParticipantOfficialFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "customEventParticipantOfficialFilter",
    filterKey: "about_official",
    dataTypeLabel: "Officials",
    selectComponent: OfficialSelect,
}

export const CustomEventParticipantStafferFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={StafferFilterableListView} {...props} />
}
CustomEventParticipantStafferFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
CustomEventParticipantStafferFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "customEventParticipantStafferFilter",
    filterKey: "about_official",
    dataTypeLabel: DjangIO.app.models.QuorumDataType.staffer.plural,
    selectComponent: StafferSelect,
}

export const CustomEventParticipantContactFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={SupporterFilterableListView} {...props} />
}
CustomEventParticipantContactFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
CustomEventParticipantContactFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "customEventParticipantContactFilter",
    filterKey: "about_supporter",
    dataTypeLabel: "Contacts",
    selectComponent: ContactSelect,
}

export const CustomEventParticipantPressContactFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={PressContactFilterableListView} {...props} />
}
CustomEventParticipantPressContactFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
CustomEventParticipantPressContactFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "customEventParticipantPressContactFilter",
    filterKey: "about_official",
    dataTypeLabel: DjangIO.app.models.QuorumDataType.press_contact.plural,
    selectComponent: PressContactSelect,
}

// date filters
export const CustomEventParticipantDateFilter = (props) => {
    const FilterComponent = props.filterComponent || enumSingleGenericFilter
    return <FilterComponent {...props} />
}
CustomEventParticipantDateFilter.propTypes = defaultEnumPropTypes
CustomEventParticipantDateFilter.defaultProps = {
    filterComponent: enumSingleGenericFilter,
    uniqueFilterId: "customEventParticipantDateFilter",
    filterKey: "event_date_time",
    enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items(),
    sortBy: enumOrderSort,
    displayLabel: "Event Date",
    helpText: "Filter for Event Participants by date of Event.",
}

export const CustomEventParticipantDatePickerStartFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
CustomEventParticipantDatePickerStartFilter.propTypes = dateDefaultPropTypes
CustomEventParticipantDatePickerStartFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "customEventParticipantDatePickerStartFilter",
    filterKey: "event__date_time__gt",
    displayLabel: "Start Date",
}

export const CustomEventParticipantDatePickerEndFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
CustomEventParticipantDatePickerEndFilter.propTypes = dateDefaultPropTypes
CustomEventParticipantDatePickerEndFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "customEventParticipantDatePickerEndFilter",
    filterKey: "event__date_time__lt",
    displayLabel: "End Date",
}
